// Get all form elements
const makeSelect = document.getElementById('make');
const harleyModelFamily = document.getElementById('harley-model-family');
const harleyModelFamilySelect = document.getElementById('harley-model-family-select');
const indianModelFamily = document.getElementById('indian-model-family');
const indianModelFamilySelect = document.getElementById('indian-model-family-select');

// Harley year dropdowns
const touringYears = document.getElementById('touring-years');
const softailYears = document.getElementById('softail-years');
const trikeYears = document.getElementById('trike-years');

// Indian year dropdown
const indianYears = document.getElementById('indian-years');

// Harley model dropdowns
const touringModels = document.getElementById('touring-models');
const softailModels = document.getElementById('softail-models');
const trikeModels = document.getElementById('trike-models');

// Indian model dropdown
const indianModels = document.getElementById('indian-models');

// Submit button
const submitButton = document.getElementById('submit-button');

// Helper function to hide all elements
function hideAll() {
    harleyModelFamily.classList.add('hidden');
    indianModelFamily.classList.add('hidden');
    touringYears.classList.add('hidden');
    softailYears.classList.add('hidden');
    trikeYears.classList.add('hidden');
    indianYears.classList.add('hidden');
    touringModels.classList.add('hidden');
    softailModels.classList.add('hidden');
    trikeModels.classList.add('hidden');
    indianModels.classList.add('hidden');
    submitButton.classList.add('hidden');
}

// Helper function to reset select values
function resetSelects() {
    harleyModelFamilySelect.value = '';
    indianModelFamilySelect.value = '';
    document.getElementById('touringYear').value = '';
    document.getElementById('softailYear').value = '';
    document.getElementById('trikeYear').value = '';
    document.getElementById('indianYear').value = '';
    document.getElementById('touringModel').value = '';
    document.getElementById('softailModel').value = '';
    document.getElementById('trikeModel').value = '';
    document.getElementById('indianModel').value = '';
}

// Make selection handler
makeSelect.addEventListener('change', function() {
    hideAll();
    resetSelects();
    
    if (this.value === 'harley-davidson') {
        harleyModelFamily.classList.remove('hidden');
    } else if (this.value === 'indian-motorcycles') {
        indianModelFamily.classList.remove('hidden');
    }
});

// Harley Model Family selection handler
harleyModelFamilySelect.addEventListener('change', function() {
    // Hide all year and model dropdowns
    touringYears.classList.add('hidden');
    softailYears.classList.add('hidden');
    trikeYears.classList.add('hidden');
    touringModels.classList.add('hidden');
    softailModels.classList.add('hidden');
    trikeModels.classList.add('hidden');
    submitButton.classList.add('hidden');
    
    // Reset year and model selections
    document.getElementById('touringYear').value = '';
    document.getElementById('softailYear').value = '';
    document.getElementById('trikeYear').value = '';
    document.getElementById('touringModel').value = '';
    document.getElementById('softailModel').value = '';
    document.getElementById('trikeModel').value = '';
    
    // Show appropriate year dropdown
    if (this.value.includes('Touring')) {
        touringYears.classList.remove('hidden');
    } else if (this.value.includes('Softail')) {
        softailYears.classList.remove('hidden');
    } else if (this.value.includes('Trike')) {
        trikeYears.classList.remove('hidden');
    }
});

// Indian Model Family selection handler
indianModelFamilySelect.addEventListener('change', function() {
    indianModels.classList.add('hidden');
    submitButton.classList.add('hidden');
    document.getElementById('indianYear').value = '';
    document.getElementById('indianModel').value = '';
    
    if (this.value.includes('Touring')) {
        indianYears.classList.remove('hidden');
    }
});

// Harley Year selection handlers
document.getElementById('touringYear').addEventListener('change', function() {
    if (this.value) {
        touringModels.classList.remove('hidden');
    }
});

document.getElementById('softailYear').addEventListener('change', function() {
    if (this.value) {
        softailModels.classList.remove('hidden');
    }
});

document.getElementById('trikeYear').addEventListener('change', function() {
    if (this.value) {
        trikeModels.classList.remove('hidden');
    }
});

// Indian Year selection handler
document.getElementById('indianYear').addEventListener('change', function() {
    if (this.value) {
        indianModels.classList.remove('hidden');
    }
});

// Harley Model selection handlers
document.getElementById('touringModel').addEventListener('change', function() {
    if (this.value) {
        submitButton.classList.remove('hidden');
    }
});

document.getElementById('softailModel').addEventListener('change', function() {
    if (this.value) {
        submitButton.classList.remove('hidden');
    }
});

document.getElementById('trikeModel').addEventListener('change', function() {
    if (this.value) {
        submitButton.classList.remove('hidden');
    }
});

// Indian Model selection handler
document.getElementById('indianModel').addEventListener('change', function() {
    if (this.value) {
        submitButton.classList.remove('hidden');
    }
});

// Form submission handler
function redirectToURL(event) {
    event.preventDefault();
    
    const make = makeSelect.value;
    let url = '/collections/all-products?';
    let filters = [];
    
    // Add make filter
    if (make === 'harley-davidson') {
        filters.push('filter.p.m.custom.make=Harley-Davidson');
        
        // Get selected model family
        const modelFamily = harleyModelFamilySelect.value;
        if (modelFamily) {
            filters.push(modelFamily);
        }
        
        // Get selected year based on model family
        let year = '';
        if (modelFamily.includes('Touring')) {
            year = document.getElementById('touringYear').value;
        } else if (modelFamily.includes('Softail')) {
            year = document.getElementById('softailYear').value;
        } else if (modelFamily.includes('Trike')) {
            year = document.getElementById('trikeYear').value;
        }
        if (year) {
            filters.push(year);
        }
        
        // Get selected model based on model family
        let model = '';
        if (modelFamily.includes('Touring')) {
            model = document.getElementById('touringModel').value;
        } else if (modelFamily.includes('Softail')) {
            model = document.getElementById('softailModel').value;
        } else if (modelFamily.includes('Trike')) {
            model = document.getElementById('trikeModel').value;
        }
        if (model) {
            filters.push(model);
        }
        
    } else if (make === 'indian-motorcycles') {
        filters.push('filter.p.m.custom.make=Indian%20Motorcycles');
        
        // Get selected model family
        const modelFamily = indianModelFamilySelect.value;
        if (modelFamily) {
            filters.push(modelFamily);
        }
        
        // Get selected year
        const year = document.getElementById('indianYear').value;
        if (year) {
            filters.push(year);
        }
        
        // Get selected model
        const model = document.getElementById('indianModel').value;
        if (model) {
            filters.push(model);
        }
    }
    
    // Construct final URL
    url += filters.join('&');
    
    // Redirect to the filtered collection page
    window.location.href = url;
}